import { jwtDecode } from 'jwt-decode';
import { getAppConfig } from '../config/appConfig';

export const getKey = (baseKey) => {
  const config = getAppConfig();
  const prefix = config.localStoragePrefix || 'platform_app';
  return `${prefix}_${baseKey}`;
};

// Only store non-sensitive user data in LocalStorage
const USER_DATA_KEY = 'user';

// Store Access Token in memory only (cleared on refresh)
let inMemoryAccessToken = null;
let tokenExpiryTime = 0;

export const saveTokens = (authData) => {
  if (!authData || !authData.access_token) {
    console.error("saveTokens: Invalid authData received", authData);
    return;
  }

  // 1. Save Access Token to Memory
  inMemoryAccessToken = authData.access_token;

  // 2. Calculate Expiry
  try {
    const decodedToken = jwtDecode(authData.access_token);
    if (decodedToken && decodedToken.exp) {
      tokenExpiryTime = decodedToken.exp * 1000;
    }
  } catch (error) {
    console.error("Error decoding access token:", error);
  }

  // 3. Save Non-Sensitive User Data to LocalStorage
  // We do NOT save refresh_token or access_token here.
  const { access_token, refresh_token, ...userData } = authData;
  localStorage.setItem(getKey(USER_DATA_KEY), JSON.stringify(userData));
};

export const getAccessToken = () => {
  return inMemoryAccessToken;
};

// The frontend no longer manages the refresh token directly.
// It is handled via HttpOnly cookies by the browser.
export const getRefreshToken = () => {
  return null; 
};

export const getTokenExpiryTime = () => {
  return tokenExpiryTime;
};

export const isTokenExpired = (bufferSeconds = 60) => {
  if (!inMemoryAccessToken || !tokenExpiryTime) {
    return true;
  }
  const currentTime = Date.now();
  const bufferMilliseconds = bufferSeconds * 1000;
  return currentTime > (tokenExpiryTime - bufferMilliseconds);
};

export const getUserData = () => {
  const userData = localStorage.getItem(getKey(USER_DATA_KEY));
  if (!userData) return null;
  try {
    return JSON.parse(userData);
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

export const clearTokens = () => {
  inMemoryAccessToken = null;
  tokenExpiryTime = 0;
  localStorage.removeItem(getKey(USER_DATA_KEY));
};

export const isAuthenticated = () => {
  return !!inMemoryAccessToken && !isTokenExpired();
};

export const updateAccessToken = (accessToken) => {
  inMemoryAccessToken = accessToken;
  try {
    const decodedToken = jwtDecode(accessToken);
    if (decodedToken && decodedToken.exp) {
      tokenExpiryTime = decodedToken.exp * 1000;
    }
  } catch (error) {
    console.error("Error decoding refreshed access token:", error);
  }
};